// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '@/components/HomeView.vue'
import BrowseView from '@/components/BrowseView.vue'
import ViewArticle from '@/components/ViewArticle.vue'
import SubmitView from '@/components/newSubmitView.vue'
import campaignsubmit from '@/components/SubmitCampaign.vue'

import MySubmissions from '@/components/MySubmissions.vue'
import AboutView from '@/components/AboutView.vue'
// import ContactView from '@/components/ContactView.vue'
// import CareerView from '@/components/CareerView.vue'
// import NewsLetterView from '@/components/NewsLetterView.vue'
import AdminView from '@/views/admin/index.vue'
import EditView from '@/components/EditView.vue'
import Campaign from '@/components/campaign.vue'
import viewCampaign from '@/components/viewCampaign.vue'
import AcceptInvitation from '@/components/AcceptInvitation.vue'

import EthicsView from '@/components/Ethics.vue' 


// import AcceptInvitation from '@/components/AcceptInvitation.vue'
const routes = [
  { path: '/author-profile', name: 'AuthorProfile', component: () => import('@/views/AuthorProfile.vue') },
  { path: '/', name: 'home', component: HomeView },
  { path: '/browse', name: 'browse', component: BrowseView },
  { path: '/article/:slug', name: 'view-article', component: ViewArticle, props: true },
  { path: '/submit', name: 'submit', component: SubmitView },
  { path: '/submit-campaign/:slug', name: 'campaignSubmit', component: campaignsubmit },
  { path: '/submission', name: 'submission', component: MySubmissions },
  { path: '/publication/ethics', name: 'ethics', component: EthicsView },  
  { path: '/about', name: 'about', component: AboutView },
  { path: '/edit/:id', name:'edit', component: EditView},
  { path: '/create-campaign', name:'campaign', component: Campaign},
  { path: '/campaign/:slug', name:'camp', component:viewCampaign},
  { path: '/accept-invite/:id', name:'AcceptInvite', component:AcceptInvitation},
  { path: '/minsu-author-guidelines', name: 'AuthorGuidelines', component: () => import('@/components/AuthorGuidelines.vue') },
  // { path: '/contact', name: 'contact', component: ContactView },
  // { path: '/careers', name: 'careers', component: CareerView },
  // { path: '/newsletter', name: 'newsletter', component: NewsLetterView },
  { path: '/adminview', name: 'adminview', component: AdminView },
  { path: '/article/:slug/review', name: 'ArticleReview', component: () => import('@/views/admin/ArticleReview.vue')},
  { path: '/institution', name: 'InstitutionView', component: () => import('@/views/InstitutionView.vue')}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
